import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import './config/firebase.ts';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import ErrorBoundary from './components/errors/ErrorBoundary.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Optimize: Data is considered fresh for 2 minutes.
      // Prevents re-fetching on window focus or quick navigation switches.
      staleTime: 1000 * 60 * 2, 
      // Garbage collect unused data after 24 hours (existing setting)
      gcTime: 1000 * 60 * 60 * 24, 
      // Retry logic
      retry: 1,
      refetchOnWindowFocus: false, // Save reads/function calls on alt-tabbing
    },
  },
});

const localStoragePersister = createSyncStoragePersister({ 
  storage: window.localStorage 
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister: localStoragePersister }}
      >
        <AuthProvider>
          <ErrorBoundary fallbackMessage="An unexpected error occurred in the application. Please try again.">
            <App />
          </ErrorBoundary>
          <SonnerToaster richColors position="top-right" />
        </AuthProvider>
      </PersistQueryClientProvider>
    </BrowserRouter>
  </React.StrictMode> 
);
